<template>
    <!--START PROTEST INFO-->
        <section class="section bg-light scroll-select" id="where-what-time">
            <div class="container">
                <div class="row vertical-content">
                    <div class="col-lg-5">
                        <div class="features-box">
                            <h3>Protest: Where / What time</h3>
                            <ul class="text-muted list-unstyled margin-t-30 features-item-list">
                                <li class="">Date: <strong>Saturday 7th September</strong></li>
                                <li class="">Where: <strong>Valletta, in front of Law Courts</strong></li>
                                <li class="">Time:  <strong>10:00am</strong></li>
                                <li class="">What to bring: <strong>Placards</strong></li>
                            </ul>
                            <a href="https://www.facebook.com/events/725406107884533/" class="btn btn-custom margin-t-30 waves-effect waves-light" target="_blank">
                                Facebook Event <i class="mdi mdi-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="features-img features-right text-right">
                            <img src="images/protest.jpg" alt="macbook image" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--END PROTEST INFO-->
</template>

<script>
export default {
  name: 'ProtestInfo',
  props: {
  }
}
</script>
